<template>
  <AtroModal fullscreen-when-mobile>
    <template #default="{ close }">
      <AtroContent class="w-full" items="center" col>
        <AtroIconSquare class="mb-6" icon-name="plus" circle />

        <AtroHeading class="mb-2 text-atro-slate-purple" semibold
          >Suggest an integration</AtroHeading
        >
        <AtroParagraph class="mb-8 text-atro-gray-1"
          >Tell us about the services you want to connect</AtroParagraph
        >

        <FormKit v-model="formData" type="form" @submit="data => onSubmit(data, close)">
          <FormKit
            autofocus
            type="text"
            label="Service name"
            placeholder="Service you want"
            name="serviceName"
            validation="required|length:2,50"
          />
          <FormKit
            autofocus
            type="textarea"
            label="Functionality"
            placeholder="What do you want this to do for you?"
            name="functionality"
          />
          <template #submit="{ state: { valid } }">
            <AtroButton class="mx-auto" :is-pending="isPending" :disabled="!valid">Send</AtroButton>
          </template>
        </FormKit>
      </AtroContent>
    </template>
  </AtroModal>
</template>

<script setup lang="ts">
import axios from '@/utils/axios'
import { Props as ModalProps } from '@/components/globals/atro/Modal.vue'
import useCurrentUser from '@/composables/data/useCurrentUser'

interface Props extends ModalProps {}

defineProps<Props>()

const { data: currentUser } = $(useCurrentUser())

let formData = $ref({
  serviceName: '',
  functionality: '',
})

let isPending = $ref(false)
const onSubmit = async (data, close) => {
  isPending = true
  try {
    await axios.post('suggestions', {
      suggestion: {
        data: {
          ...data,
          email: currentUser.email,
        },
        table: 'Integrations',
      },
    })
    close()
  } catch (e) {}
  isPending = false
}
</script>
